import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PagedListForm } from '../../../../base/controlers/paged-list-form';
import { fromEvent } from 'rxjs';
import { filter, debounceTime, distinctUntilChanged, tap, map } from 'rxjs/operators';
import { CustomerPortal } from '../../models/customer-portal';
import { Router } from '@angular/router';
import { CustomerPortalService } from '../../services/customer-portal.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { CustomerPortalViewComponent } from '../customer-portal-view/customer-portal-view.component';

@Component({
  selector: 'app-customer-portal-list',
  templateUrl: './customer-portal-list.component.html',
  styleUrls: ['./customer-portal-list.component.css']
})
export class CustomerPortalListComponent extends PagedListForm<CustomerPortal> implements OnInit, AfterViewInit {

  public displayedColumns = ['actions','name','date','email','telepohone','address','city','actuality','company'];
  @ViewChild('search',{static:true}) search: ElementRef;
  constructor(
    protected customerPortalService: CustomerPortalService,
    protected router:Router,
    private dialog: MatDialog
  ) {
    super(customerPortalService,'/plasard-measurement/customer',router,null,'created',true);
   }

  ngOnInit() {
    super.ngOnInit();
  }
  ngAfterViewInit() {
    // server-side search
    fromEvent(this.search.nativeElement,'keyup')
        .pipe(
            filter(Boolean),
            debounceTime(300),
            distinctUntilChanged(),
            tap((_) => {
              const filter = this.search.nativeElement.value.trim();
              let query = null;
              if(filter){
                query = `contains(code, '${filter}') or contains(name, '${filter}') or contains(email, '${filter}') or contains(telepohone, '${filter}') or contains(address, '${filter}') or contains(city, '${filter}')`;
              }
              this.onFilter(query);
            })
        )
        .subscribe();
    }
    onView(item:CustomerPortal){
      if(item){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = item;
        dialogConfig.width = "1080";
        dialogConfig.panelClass = 'preview-dialog'
    
        const dialogRef = this.dialog.open(CustomerPortalViewComponent, dialogConfig);
        return dialogRef.afterClosed().pipe(map(
          ret => {
            return ret;
          }
        ));
      }
    }  

}
